import React from "react";
import { Controller } from "react-hook-form";

const SelectField = ({ label, name, control, options = [], rules, error,   disabled = false, }) => {
  return (
    <div className="mb-4">
      {label && (
        <label
          htmlFor={name}
          className="block mb-1 text-sm font-semibold text-green-800"
        >
          {label}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <select
            {...field}
            id={name}
            disabled={disabled}
            className={`w-full px-3 py-2 text-sm transition border rounded-md focus:ring-2 
              ${
                error
                  ? "border-red-500 focus:ring-red-300"
                  : "border-green-300 focus:ring-green-400"
              }`}
          >
            <option value="">-- Pilih --</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}
      />

      {error && <p className="mt-1 text-xs text-red-500">{error.message}</p>}
    </div>
  );
};

export default SelectField;
